export const MyFunctions = {
    colors_Gr: function(data) {

        if(0<= data && data<= 30){
          return '#1C8BC2'
        }
        if(31<= data && data<= 80 ){
          return '#8EC4CD'
        }
        if(81<= data && data<= 150 ){
          return '#F7FFA7'
        }
        if(151<= data && data <= 250){
          return '#FDE97D'
        }
        if(251<= data && data <= 375){
          return '#ffd27d'
        }
        if(376<= data && data <= 500){
          return '#FFC262'
        }
        if(501<= data && data <= 750){
          return '#FBAE5F'
        }
        if(751<= data && data <= 1000){
          return '#FB7C47'
        }
        if(1001<= data && data <= 1250){
          return '#F94626'
        }
        if(data > 1250){
          return '#D40414'
        }
      },
    
      colors_It_culex: function(data) {

        if(data===0){
          return '#1C8BC2'
        }
        else if(data===1){
          return '#8EC4CD'
        }
        else if(data===2){
          return '#F7FFA7'
        }
        else if(data===3){
          return '#FDE97D'
        }
        else if(data===4){
          return '#FFD27D'
        }
        else if(data===5){
          return '#FFC262'
        }
        else if(data===6){
          return '#FBAE5F'
        }
        else if(data===7){
          return '#FB7C47'
        }
        else if(data===8){
          return '#F94626'
        }
        else if(data===9){
          return '#D40414'
        }
      },
      colors_It_anopheles: function(data) {

        if(data===0){
          return '#1C8BC2'
        }
        else if(data===1){
          return '#8EC4CD'
        }
        else if(data===2){
          return '#F7FFA7'
        }
        else if(data===3){
          return '#FDE97D'
        }
        else if(data===4){
          return '#FFD27D'
        }
        else if(data===5){
          return '#FFC262'
        }
        else if(data===6){
          return '#FBAE5F'
        }
        else if(data===7){
          return '#FB7C47'
        }
        else if(data===8){
          return '#F94626'
        }
        else if(data===9){
          return '#D40414'
        }
      },
      colors_Fr_culex: function(data) {

        if(data===0){
          return '#1C8BC2'
        }
        if(1<= data && data<= 3 ){
          return '#8EC4CD'
        }
        if(4<= data && data<= 7 ){
          return '#F7FFA7'
        }
        if(8<= data && data <= 10){
          return '#FDE97D'
        }
        if(11<= data && data <= 15){
          return '#ffd27d'
        }
        if(16<= data && data <= 22){
          return '#FFC262'
        }
        if(23<= data && data <= 29){
          return '#FBAE5F'
        }
        if(30<= data && data <= 59){
          return '#FB7C47'
        }
        if(60<= data && data <= 205){
          return '#F94626'
        }
        if(data > 205){
          return '#D40414'
        }
      },
      colors_Fr_aedes: function(data) {

        if(data===0){
          return '#1C8BC2'
        }
        if(1<= data && data<= 5 ){
          return '#8EC4CD'
        }
        if(6<= data && data<= 15 ){
          return '#F7FFA7'
        }
        if(16<= data && data <= 31){
          return '#FDE97D'
        }
        if(32<= data && data <= 54){
          return '#ffd27d'
        }
        if(55<= data && data <= 80){
          return '#FFC262'
        }
        if(81<= data && data <= 135){
          return '#FBAE5F'
        }
        if(136<= data && data <= 219){
          return '#FB7C47'
        }
        if(220<= data && data <= 400){
          return '#F94626'
        }
        if(data > 400){
          return '#D40414'
        }
      },
      colors_Iv_aedes: function(data) {

        if(data===0){
          return '#1C8BC2'
        }
        if(1<= data && data<= 1 ){
          return '#8EC4CD'
        }
        if(2<= data && data<= 2 ){
          return '#F7FFA7'
        }
        if(3<= data && data <= 4){
          return '#FDE97D'
        }
        if(5<= data && data <= 7){
          return '#ffd27d'
        }
        if(9<= data && data <= 10){
          return '#FFC262'
        }
        if(11<= data && data <= 13){
          return '#FBAE5F'
        }
        if(14<= data && data <= 22){
          return '#FB7C47'
        }
        if(23<= data && data <= 40){
          return '#F94626'
        }
        if(data > 40){
          return '#D40414'
        }
      },
      colors_Ge_culex: function(data) {

        if(data===0){
          return '#1C8BC2'
        }
        if(1<= data && data<= 4 ){
          return '#8EC4CD'
        }
        if(5<= data && data<= 7 ){
          return '#F7FFA7'
        }
        if(8<= data && data <= 10){
          return '#FDE97D'
        }
        if(11<= data && data <= 15){
          return '#ffd27d'
        }
        if(16<= data && data <= 22){
          return '#FFC262'
        }
        if(23<= data && data <= 36){
          return '#FBAE5F'
        }
        if(37<= data && data <= 77){
          return '#FB7C47'
        }
        if(78<= data && data <= 206){
          return '#F94626'
        }
        if(data > 206){
          return '#D40414'
        }
      },
      colors_Se_culex: function(data) {

        if(0<= data && data<= 18){
          return '#1C8BC2'
        }
        if(19<= data && data<= 55 ){
          return '#8EC4CD'
        }
        if(56<= data && data<= 115 ){
          return '#F7FFA7'
        }
        if(116<= data && data <= 197){
          return '#FDE97D'
        }
        if(198<= data && data <= 202){
          return '#ffd27d'
        }
        if(203<= data && data <= 313){
          return '#FFC262'
        }
        if(314<= data && data <= 482){
          return '#FBAE5F'
        }
        if(483<= data && data <= 731){
          return '#FB7C47'
        }
        if(732<= data && data <= 1225){
          return '#F94626'
        }
        if(data > 1225){
          return '#D40414'
        }
      },


  };